/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { UserManager } from '@forgerock/javascript-sdk';
// import { isNil } from 'lodash';
import isNil from 'lodash/isNil';
import { JSXElementConstructor, useEffect, useState } from 'react';
import RequestRoleResource from '../../../components/forms/RoleRequest/requestRoleResource';
import RoleRequestSelectOrgEngine from '../../../components/forms/RoleRequest/RoleRequestSelectOrg';
import SuccessPage from '../../../components/forms/RoleRequest/SuccessPage';
import SuccessErrorModal, { MessageType } from '../../../components/modals/SuccessErrorModal';
import idmRequest from '../../../lib/idmRequest';
import { useAppSelector } from '../../../redux/hooks';
import { isLoggedInSelector } from '../../../redux/loginSlice';
import styles from '../../../styles/FormLayout.module.css';
import myResStyles from '../../../styles/myResources.module.css';
import { FormContainer } from 'react-hook-form-mui';
import Loading from '../../02-molecules/Loading';
import ResourceStatus from './resourceStatus';

const MyRoleResources = () => {



  const [roleRequestData, setroleRequestData] = useState<any>();
  const [completedResNameGroupedData, setCompletedResNameGroupedData] = useState<any>();
  const [pendingResNameGroupedData, setPendingResNameGroupData] = useState<any>();
  const [message, setMessage] = useState('');
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [showContent, setShowContent ] = useState({completed : true,pending :true});

  const header: string = "My resources"
  const subHeaderDescription: string = "Below is a summary of resources with active access. Resources with pending status may take up to three days for approval. For further assistance, select contact to view resource client admins."


  const handleOpen = () => {
    setIsAlertOpen(true);
  };
  const handleClose = () => {
    setIsAlertOpen(false);
  };

  useEffect(() => {
    (async () => {
      try {
        await getRoleStatusList();
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  useEffect(()=> {
    if (roleRequestData?.RolesInfo.length === 0){
      setShowContent({completed : false,pending :true})
    }
    if(roleRequestData?.pendingRequests.length===0){
      setShowContent({completed : true,pending :false})
    }
    if(roleRequestData?.RolesInfo.length === 0 && roleRequestData?.pendingRequests.length === 0){
      setShowContent({completed : false,pending :false})
    }
  },[roleRequestData]);


  
  const getRoleStatusList = async () => {
    const data = await idmRequest('/endpoint/getUserRolesList?callFor=RolesList', 'get');
    if (!isNil(data)) {
      console.log("Data ===================== ",data)
      const completedGroupedroles= new Map<string,any>();
      const pendingGroupedroles= new Map<string,any>();
      data.RolesInfo.forEach((info:any)=>{ 
        const key = info.resourceName
        // if(!info.processVariables.taskDeleted && !info.processVariables.rejected){
        const values = completedGroupedroles.get(key);
        if(!values){
          completedGroupedroles.set(key,[info])
        } else {
          values.push(info)
        }
      // }
      })

      data.pendingRequests.forEach((info:any)=>{ 
        const key = info.processVariables.resourceName
        const values = pendingGroupedroles.get(key);
        if(!values){
          pendingGroupedroles.set(key,[info])
        } else {
          values.push(info)
        }
      })
      
      setIsAlertOpen(false)
      setroleRequestData(data);
      setCompletedResNameGroupedData(completedGroupedroles)
      setPendingResNameGroupData(pendingGroupedroles)
    }
    else {
      setIsAlertOpen(true);
      setMessage('Failed to load organization and engine Models');
    }
  }




  const getCompletedRoleRequestsGrouped = () => {
    let uiElement: JSX.Element = <></>;
    let children: JSX.Element[] = [];
  
    if(!isNil(completedResNameGroupedData)){

      for (const [key, value] of completedResNameGroupedData) { 
        children.push(
          <div className={myResStyles.rolesStatus}>
            {getCompletedRoleRequests(value)}
          </div>
        )
      }   
            uiElement = <div>{children}</div>;
            return uiElement;
    }
    else{
      return <></>;
    }
  }


  const getCompletedRoleRequests = ( value: any) => {
    let uiElement: JSX.Element = <></>;
    let children: JSX.Element[] = [];    
    if (!isNil(value) ) {
      value.forEach((info: any) => {
        children.push(
          <ResourceStatus resouceData = {info} reourceColor = {'#5B6376'} roleStatus = {'Active'} icon={'check'}></ResourceStatus>
        );
      });
      uiElement = <div>{children}</div>;
      return uiElement;
    }
    return <></>;
  };


  // const getCompletedRoleRequests = () => {
  //   let uiElement: JSX.Element = <></>;
  //   let children: JSX.Element[] = [];
  //   if (!isNil(roleRequestData) && !isNil(roleRequestData.completedRequests)) {
  //     roleRequestData.completedRequests.forEach((info: any) => {
  //       if(!info.processVariables.taskDeleted && !info.processVariables.rejected){
  //         children.push(
  //           <ResourceStatus resouceData = {info} reourceColor = {'#5B6376'} roleStatus = {'Active'} icon={'check'}></ResourceStatus>
  //         );
  //       }
  //     });
  //     uiElement = <div>{children}</div>;
  //     return uiElement;
  //   }
  //   return <></>;
  // };


// pending roles as per figma //



  const getPendingRoleRequestsGrouped = () => {
    let uiElement: JSX.Element = <></>;
    let children: JSX.Element[] = [];
  
    if(!isNil(pendingResNameGroupedData)){

      for (const [key, value] of pendingResNameGroupedData) { 
        children.push(
          <div className={myResStyles.rolesStatus}>
            {getPendingRoleRequests(value)}
          </div>
        )
      }   
            uiElement = <div>{children}</div>;
            return uiElement;
    }
    else{
      return <></>;
    }
  }


  const getPendingRoleRequests = ( value: any) => {
    let uiElement: JSX.Element = <></>;
    let children: JSX.Element[] = [];
    if (!isNil(value) ) {
      value.forEach((info: any) => {
        children.push(
          <ResourceStatus resouceData = {info} reourceColor = {'#00A9E0'} roleStatus = {'Pending'} icon={'sync'}></ResourceStatus>
        );
      });
      uiElement = <div>{children}</div>;
      return uiElement;
    }
    return <></>;
  };

  return (
    <>
      <div className={styles.container}>
        <main className={styles.mainmyroles}>
          <div className={styles.headerGrouproles}>
            {header && (
              <div
                className={`brand-voice ${styles.header}`}
                dangerouslySetInnerHTML={{ __html: header }}
              ></div>
            )}
            {subHeaderDescription && subHeaderDescription && (
              <div
                className={styles.subHeader}
                dangerouslySetInnerHTML={{ __html: subHeaderDescription }}
              ></div>
            )}

            <div className={myResStyles.border}>
              <div className={styles.headerbox}>
                <div className={styles.headerboxlable1}>Resource</div>
                <div className={styles.headerboxlable2}>Role</div>
                <div className={styles.headerboxlable3}>Status</div>
                <div className={styles.headerboxlable4}>Support</div>
              </div>
              {
                roleRequestData ? 
                (<>
                  {showContent.pending && (
                    <div className={myResStyles.content}>
                     <div className={myResStyles.sideHeaderContainer}>
                      <div className={myResStyles.sideheader} dangerouslySetInnerHTML={{ __html: "Pending " }} ></div>
                     </div>
                      {getPendingRoleRequestsGrouped()}
                    </div>
                  )}
                  {showContent.completed && (
                    <div className={myResStyles.content}>
                      <div className={myResStyles.sideHeaderContainer}>
                      <div className={myResStyles.sideheader} dangerouslySetInnerHTML={{__html: "Active" }} ></div>
                      
                      </div>
                      {getCompletedRoleRequestsGrouped()}
                    </div>
                  )}
                </>)
                : (<div style={{ marginTop: '10px', marginBottom: '40px' , border :'1px solid white'}} className="lowHeight">
                <Loading size={100}/>
              </div>)
              }
            </div>
          </div>
        </main>
      </div>
    </>
  );

};

export default MyRoleResources;